import { css } from "@emotion/react";

export const wrapper = css`
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  flex-wrap: wrap;
  margin: 3rem 0;
`;

export const description = css`
  margin-top: .5rem;
  text-align: left;
  font-size: 1.4rem;
`;
